import axios from './index';

export const getPagingAndOrderParams = (newActiveFilters, searchParams) => {

    if (!newActiveFilters)
        return;

    searchParams.delete('pageIndex'); // se resetea el paginado
    if (newActiveFilters.pagination?.page) {
        searchParams.append('pageIndex', newActiveFilters.pagination.page);
    }
    searchParams.delete('pageSize');
    if (newActiveFilters.pagination?.sizePerPage) {
        searchParams.append('pageSize', newActiveFilters.pagination.sizePerPage);
    }
    searchParams.delete('sortField');
    if (newActiveFilters.sort?.sortField) {
        searchParams.append('sortField', newActiveFilters.sort.sortField);
    }
    searchParams.delete('sortOrder');
    if (newActiveFilters.sort?.sortOrder) {
        searchParams.append('sortOrder', newActiveFilters.sort.sortOrder);
    }

    return searchParams;
}

export const getQueryString = (query, search) => {

    var searchParams = new URLSearchParams(search || '');

    if (!query)
        return searchParams.toString();

    searchParams = getPagingAndOrderParams(query, searchParams);

    if (query.filters) {
        for (const property in query.filters) {

            searchParams.delete(property);
            if (query.filters[property] !== null && query.filters[property] !== undefined) {
                searchParams.append(property, query.filters[property]);
            }
        }
    }

    searchParams.delete('q');
    if (query.query) {
        searchParams.append('q', query.query);
    }

    return searchParams.toString();
}

const transformRequestOptions = (params) => {
    let options = '';
    if (params.ids) {
        params.ids.forEach((id) => {
            options += `ids=${id}&`;
        });
    }
    if (params.branchIds && params.branchIds.length > 0) {
        params.branchIds.forEach((id) => {
            options += `branchIds=${id}&`;
        });
    }
    return options.replace(/&$/, '');
};

//#region Admin
export const getMasterData = (items) => {
    const itemsParams = new URLSearchParams(window.location.search || '');
    itemsParams.delete('items');
    items.forEach(item => itemsParams.append('items', item));
    return axios.get(`api/v1/protocols/selectmasterdata?${itemsParams}`);
};

export const getStudyTasks = (protocolId) => {
    return axios.get(`api/v1/protocols/${protocolId}/studyTasks`);
};
//#endregion


//#region Protocols
export const getProtocols = async (filters) => {
    const queryString = getQueryString(filters, window.location.search);
    return axios.get(queryString ? `api/v1/protocols/?${queryString}` : `api/v1/protocols`);
};
export const getProtocolsById = async (protocolsIds = []) => {
    const params = new URLSearchParams();
    protocolsIds.forEach(id => params.append('ids', id));
    return axios.get(`api/v1/protocols/protocolsbyid?${params.toString()}`);
};
export const getProtocol = async (protocolId) => {
    return axios.get(`api/v1/protocols/${protocolId}`);
};
export const createProtocol = async (protocol) => {
    return axios.post(`api/v1/protocols/`, protocol);
};
export const editProtocol = async (protocolId, protocol) => {
    return axios.put(`api/v1/protocols/${protocolId}`, protocol);
};
export const closeProtocolApi = async (protocolId) => {
    return axios.post(`api/v1/protocols/${protocolId}/close`, null);
}; 

export const reopenProtocolApi = async (protocolId) => {
    return axios.put(`api/v1/protocols/${protocolId}/reopen`, null);
};

export const removeProtocolApi = async (protocolId) => {
    return axios.delete(`api/v1/protocols/${protocolId}/remove`, null);
};
/*export const uploadAttachment = async (protocolId, formData) => {
    return axios.post(`api/v1/protocols/${protocolId}/attachments/`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}*/
export const uploadAttachmentEndpoint = (protocolId) => {
    return `api/v1/protocols/${protocolId}/attachments/`;
}
export const getAttachments = (protocolId) => {
    return axios.get(`api/v1/protocols/${protocolId}/attachments`);
};
export const getAttachment = (protocolId, attachmentId) => {
    return axios.get(`api/v1/protocols/${protocolId}/attachments/${attachmentId}`, { responseType: 'blob' });
};
export const getAttachmentEndpoint = (protocolId) => {
    return `api/v1/protocols/${protocolId}/attachments`;
};
export const removeAttachment = (protocolId, attachmentId) => {
    return axios.delete(`api/v1/protocols/${protocolId}/attachments/${attachmentId}`);
};

export const uploadPractitionerAttachment = async (protocolId, practitionerId, formData) => {
    return axios.post(`api/v1/protocols/${protocolId}/practitioners/${practitionerId}/attachments`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
export const getPractitionerAttachmentsEndpoint = (protocolId, practitionerId) => {
    return `api/v1/protocols/${protocolId}/practitioners/${practitionerId}/attachments`;
}

export const getPractitioners = async (protocolId, filters) => {
    const queryString = getQueryString(filters, window.location.search);
    return axios.get(queryString ? `api/v1/protocols/${protocolId}/practitioners?${queryString}` : `api/v1/protocols/${protocolId}/practitioners`);
};
export const getPractitionersByProtocol = (protocolId, q, isInternalNote = false, isExternalNote = false) => {
    //const queryString = getQueryString(filters, window.location.search);
    return axios.get(`api/v1/protocols/${protocolId}/practitioners/simple?q=${q}&onlyDoctor=false&sortField=FullName&sortOrder=desc&pageSize=50&isInternalNote=${isInternalNote}&isExternalNote=${isExternalNote}`);
};
export const getPractitioner = async (protocolId, practitionerUserId) => {
    return axios.get(`api/v1/protocols/${protocolId}/practitioners/${practitionerUserId}`);
};
export const addPractitioners = async (protocolId, practitioners) => {
    return axios.post(`api/v1/protocols/${protocolId}/practitioners`, practitioners);
};
export const editPractitioner = async (protocolId, practitionerUserId, practitioner) => {
    return axios.put(`api/v1/protocols/${protocolId}/practitioners/${practitionerUserId}`, practitioner);
};
export const removePractitioner = async (protocolId, practitionerId, reason, comment) => {
    return axios.delete(`api/v1/protocols/${protocolId}/practitioners/${practitionerId}/audit/${reason}/${comment}`);
};

export const getPatients = async (protocolId, filters) => {
    const queryString = getQueryString(filters, window.location.search);
    return axios.get(queryString ? `api/v1/protocols/${protocolId}/patients?${queryString}` : `api/v1/protocols/${protocolId}/patients`);
};
export const addPatients = async (protocolId, patients) => {
    return axios.post(`api/v1/protocols/${protocolId}/patients`, patients);
};
export const changePatientNumber = async (protocolId, medicalRecordNumber, patient) => {
    return axios.put(`api/v1/protocols/${protocolId}/patients/${medicalRecordNumber}`, patient);
};
export const referPatient = async (protocolId, numberInProtocol, patient) => {
    return axios.put(`api/v1/protocols/${protocolId}/patients/${numberInProtocol}/refer`, patient);
}
export const removePatient = async (protocolId, numberInProtocol) => {
    return axios.delete(`api/v1/protocols/${protocolId}/patients/${numberInProtocol}`);
};
//#endregion

//#region Visits
export const getAllVisits = async (protocolId, filters) => {
    const queryString = getQueryString(filters, window.location.search);
    return axios.get(queryString ? `api/v1/protocols/${protocolId}/visitsTemplates/allversions/?${queryString}` : `api/v1/protocols/${protocolId}/visitsTemplates/allversions`);
};
export const getApprovedVisits = async (protocolId) => {
    return axios.get(`api/v1/protocols/${protocolId}/visitsTemplates`);
};
export const getVisits = async (protocolId) => {
    return axios.get(`api/v1/protocols/${protocolId}/visitsTemplates/all`);
};
export const getVisit = async (protocolId, visitId) => {
    return axios.get(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}`);
};
export const createVisit = async (protocolId, visit) => {
    return axios.post(`api/v1/protocols/${protocolId}/visitsTemplates/create`, visit);
};
export const copyVisit = async (protocolId, visitId, visit) => {
    return axios.post(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}/copy`, visit);
};
export const copyVisitsAPI = async (protocolId, fromProtocolId, selectedVisitIds, branchIds = []) => {
    return axios.post(`api/v1/protocols/${protocolId}/visitsTemplates/copyFrom/${fromProtocolId}`, null, {
        params: { ids: selectedVisitIds, branchIds },
        paramsSerializer: transformRequestOptions,
    });
};
export const editVisit = async (protocolId, visitId, visit) => {
    return axios.put(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}`, visit);
};
export const removeVisit = async (protocolId, visitId) => {
    return axios.delete(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}`);
};
export const swapVisits = async (protocolId, visitId, visitToSwapId) => {
    return axios.put(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}/swap/${visitToSwapId}`);
}
export const getVisitHistory = async (protocolId, visitId) => {
    return axios.get(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}/history`);
};
export const publishVisit = async (protocolId, visitId, comments) => {
    return axios.post(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}/history/${comments}`);
};
export const printVisit = async (protocolId, visitId) => {
    return axios.get(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}/export`, {
        responseType: 'blob',
        timeout: 30000,
    });
};
//#endregion

//#region Forms
export const getForms = async (protocolId, visitId) => {
    return axios.get(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}/forms`);
};
export const getForm = (protocolId, visitId, formId) => {
    return axios.get(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}/forms/${formId}`);
};
export const createForm = (protocolId, visitId, form) => {
    return axios.post(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}/forms/create`, form);
};
export const copyFormsAPI = (protocolId, visitId, fromProtocolId, fromVisitId, formsToCopyIds) => {
    return axios.post(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}/forms/copyFrom/${fromProtocolId}/${fromVisitId}`, null, {
        params: { ids: formsToCopyIds },
        paramsSerializer: transformRequestOptions,
    });
};
export const editForm = (protocolId, visitId, formId, form) => {
    return axios.put(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}/forms/${formId}`, form);
};
export const removeForm = (protocolId, visitId, formId) => {
    return axios.delete(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}/forms/${formId}`);
};
export const sortForms = async (protocolId, visitId, sortedForms) => {
    return axios.put(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}/forms/sort`, sortedForms);
}
export const replicateFormToVisitsAPI = (protocolId, visitId, formId, visitIds) => {
    return axios.post(`api/v1/protocols/${protocolId}/visitsTemplates/${visitId}/forms/${formId}/replicateTo`, { visitIds });
};
export const getVisitsWithFormByTitleAPI = (protocolId, excludeVisitId, title) => {
    return axios.get(`api/v1/protocols/${protocolId}/visitsTemplates/${excludeVisitId}/forms/findByTitle`, { params: { title } });
};
export const deleteFormFromVisitsAPI = (protocolId, excludeVisitId, formTitle, visitIds) => {
    return axios.post(`api/v1/protocols/${protocolId}/visitsTemplates/${excludeVisitId}/forms/deleteFrom`, { formTitle, visitIds });
};
//#endregion

//#region Visit Tracking
export const getVisitsTracking = async (protocolId, query) => {
    const queryString = getQueryString(query, window.location.search);
    return axios.get(queryString ? `api/v1/visitTracking/${protocolId}/visitTracking?${queryString}` : `api/v1/visitTracking/${protocolId}/visitTracking`);
};
export const getVisitsTrackingTimeLineAPI = async (protocolId, patientId) => {
    return axios.get(`api/v1/visitTracking/${protocolId}/patient/${patientId}/timeline`);
};
export const getVisitTracking = async (protocolId, visitId, patientId) => {
    return axios.get(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}`);
};
export const getPreviousVisitTracking = async (protocolId, visitId, patientId) => {
    return axios.get(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/prev`);
};
export const getVisitTrackingForms = async (protocolId, visitId, patientId) => {
    return axios.get(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/forms`);
};
export const getVisitTrackingForm = async (protocolId, visitId, formId) => {
    return axios.get(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/forms/${formId}`);
};
export const createVisitTracking = async (protocolId, visitId, patientId, protocolPatientSync) => {
    return axios.post(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}`, protocolPatientSync || {});
};
export const saveVisitTracking = async (protocolId, visitId, patientId, medicalRecordNumber, form) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/${medicalRecordNumber}`, form);
};
export const saveUploadVisitTrackingAPI = async (protocolId, visitId, patientId, medicalRecordNumber, form) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/${medicalRecordNumber}/saveUpload`, form);
};
export const publishVisitTracking = async (protocolId, visitId, patientId, digitalSign) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/publish`, digitalSign);
};
export const skipVisitTracking = async (protocolId, visitId, patientId, digitalSign) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/skip`, digitalSign);
};
export const screenFailureVisitTracking = async (protocolId, visitId, patientId, digitalSign) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/screenFailure`, digitalSign);
};
export const lostToFollowUpVisitTracking = async (protocolId, visitId, patientId, digitalSign) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/lostToFollowUp`, digitalSign);
};
export const discontinuationVisitTracking = async (protocolId, visitId, patientId, earlyTerminationWillBeCreated, digitalSign) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/discontinuation/earlyTermination/${earlyTerminationWillBeCreated}`, digitalSign);
};
export const withoutDrugsVisitTracking = async (protocolId, visitId, patientId) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/withoutDrugs`, null);
};
export const returnDrugsVisitTracking = async (protocolId, visitId, patientId) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/returnDrugs`, null);
};
export const reSyncVisitTrackingAPI = async (protocolId, visitId, patientId, digitalSign) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/resync`, digitalSign);
};
export const changeTypeVisitTrackingAPI = async (protocolId, visitId, patientId, type) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/changeType/${type}`, null);
};
export const changeVisitTrackingTypeAPI = async (protocolId, visitId, patientId, entryId, visitTrackingId) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/entry/${entryId}/visit/${visitTrackingId}/changeVisitTrackingType`, null);
};
export const removeVisitTrackingAPI = async (protocolId, visitId, patientId, reason) => {
    return axios.delete(`api/v1/visitTracking/protocols/${protocolId}/visitTracking/${visitId}/patient/${patientId}`, { data: reason });
};
export const getDeletedVisitsLogAPI = async (protocolId, pageSize = 10, pageIndex = 0) => {
    return axios.get(`api/v1/visitTracking/protocols/${protocolId}/deletedVisitsLog?pageSize=${pageSize}&pageIndex=${pageIndex}`);
};
export const getDeletedVisitAPI = async (logId) => {
    return axios.get(`api/v1/visitTracking/deletedVisit/${logId}`);
};
export const endPatientInProtocolVisitTrackingAPI = async (protocolId, visitId, patientId, data) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/endProtocol`, data);
};
export const rollbackVisitStatusAPI = async (protocolId, visitId, patientId, audit) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/rollbackStatus`, audit);
};
// TODO: Connect backend - Visit Offset Overrides per patient
export const getVisitOffsetOverrides = async (protocolId, patientId = null) => {
    const query = patientId ? `?patientId=${patientId}` : '';
    return axios.get(`api/v1/visitTracking/${protocolId}/offset-overrides${query}`);
};
export const saveVisitOffsetOverride = async (protocolId, override) => {
    return axios.put(
        `api/v1/visitTracking/${protocolId}/offset-overrides/patient/${override.patientId}/visit/${override.visitCrossVersionId}`,
        override
    );
};
export const removeVisitOffsetOverride = async (protocolId, patientId, visitCrossVersionId) => {
    return axios.delete(`api/v1/visitTracking/${protocolId}/offset-overrides/patient/${patientId}/visit/${visitCrossVersionId}`);
};
export const uploadVisitTrackingAttachmentFormEndpoint = (protocolId, visitId, formId, patientId, medicalRecordNumber) => `api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/${medicalRecordNumber}/attachments/${formId}`;

export const getVisitTrackingAttachmentFormEndpoint = (protocolId, visitId, formId) => `api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/attachments/${formId}/fileName`;
export const getPendingAttachmentsAPI = async (protocolId, visitId, patientId) => {
    return axios.get(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/pendingAttachments`);
};
export const getExtraPendingAttachmentsAPI = async (protocolId, visitId, patientId) => {
    return axios.get(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/pendingAttachments`);
};
//#endregion

//#region ExtraVisitTracking
export const getVisitTrackingExtraForms = async (protocolId, visitId, patientId) => {
    return axios.get(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/forms`);
};
export const createVisitTrackingExtra = async (protocolId, patientId, vm) => {
    return axios.post(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/patient/${patientId}`, vm);
};
export const saveVisitTrackingExtraForm = async (protocolId, visitId, patientId, form) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}`, form);
};
export const saveUploadVisitTrackingExtraAPI = async (protocolId, visitId, patientId, medicalRecordNumber, form) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/${medicalRecordNumber}/saveUpload`, form);
};
export const publishVisitTrackingExtraForm = async (protocolId, visitId, patientId, form) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/publish`, form);
};
export const discontinuationVisitTrackingExtraAPI = async (protocolId, visitId, patientId, earlyTerminationWillBeCreated, digitalSign) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/discontinuation/earlyTermination/${earlyTerminationWillBeCreated}`, digitalSign);
}
export const screenFailureVisitTrackingExtra = async (protocolId, visitId, patientId, digitalSign) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/screenFailure`, digitalSign);
};
export const endPatientInProtocolVisitTrackingExtraAPI = async (protocolId, visitId, patientId, data) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/endProtocol`, data);
};
export const rollbackVisitStatusExtraAPI = async (protocolId, visitId, patientId, audit) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/rollbackStatus`, audit);
};
export const lostToFollowUpVisitTrackingExtraAPI = async (protocolId, visitId, patientId, digitalSign) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/lostToFollowUp`, digitalSign);
};
export const withoutDrugsVisitTrackingExtraAPI = async (protocolId, visitId, patientId) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/withoutDrugs`, null);
};
export const returnDrugsVisitTrackingExtraAPI = async (protocolId, visitId, patientId) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/returnDrugs`, null);
};
export const removeVisitTrackingExtraAPI = async (protocolId, visitId, patientId, reason) => {
    return axios.delete(`api/v1/visitTracking/protocols/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}`, { data: reason });
};
export const uploadVisitTrackingExtraAttachmentFormEndpoint = (protocolId, visitId, formId, patientId) => `api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/attachments/${formId}`;

export const changeTypeVisitTrackingExtraAPI = async (protocolId, visitId, patientId, type) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/changeType/${type}`, null);
};
//#endregion

export const getVisitTrackingAdverseEvents = async (protocolId, visitId, patientId) => {
    return axios.get(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/adverseEvents`);
};
export const exportVisitTrackingAPI = async (protocolId, visitId, patientId, pin) => {
    return axios.get(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/export/${btoa(pin)}`, { responseType: 'blob' });
};
export const saveEvolutionAPI = async (protocolId, visitId, patientId, medicalRecordNumber, evolution) => {
    return axios.post(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/${medicalRecordNumber}/evolution`, evolution);
};
export const updateEvolutionAPI = async (protocolId, visitId, patientId, evolutionId, evolution) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTracking/${visitId}/patient/${patientId}/evolution/${evolutionId}`, evolution);
};
export const saveEvolutionExtraAPI = async (protocolId, visitId, patientId, medicalRecordNumber, evolution) => {
    return axios.post(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/${medicalRecordNumber}/evolution`, evolution);
};
export const updateEvolutionExtraAPI = async (protocolId, visitId, patientId, evolutionId, evolution) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/visitTrackingExtra/${visitId}/patient/${patientId}/evolution/${evolutionId}`, evolution);
};
export const updateFormRestrictionsAPI = async (protocolId, restrictions) => {
    return axios.put(`api/v1/visitTracking/${protocolId}/formRestrictions`, restrictions);
};


//#region DocumentNotes
export const getDocumentNotes = async (protocolId, documentId) => {
    return axios.get(`api/v1/visitTracking/DocumentNotes/${documentId}/protocol/${protocolId}`);
};
export const getDocumentNote = async (protocolId, noteId) => {
    return axios.get(`api/v1/visitTracking/DocumentNotes/protocol/${protocolId}/note/${noteId}`);
};
export const createDocumentNote = async (documentId, protocolId, visitId, patientId, note) => {
    return axios.post(`api/v1/visitTracking/DocumentNotes/${documentId}/protocol/${protocolId}/visit/${visitId}/patient/${patientId}`, note);
};
export const updateDocumentNote = async (protocolId, noteId, note) => {
    return axios.put(`api/v1/visitTracking/DocumentNotes/protocol/${protocolId}/note/${noteId}`, note);
};
export const changeStatusDocumentNote = async (protocolId, noteId, note) => {
    return axios.put(`api/v1/visitTracking/DocumentNotes/protocol/${protocolId}/note/${noteId}/status`, note);
};
//#endregion

//#region MonitorNotes
export const getExternalNotes = async (protocolId, filters) => {
    const queryString = getQueryString(filters, window.location.search);
    return axios.get(queryString ? `api/v1/visitTracking/DocumentNotes/monitornote/protocol/${protocolId}?${queryString}` : `api/v1/visitTracking/DocumentNotes/monitornote/protocol/${protocolId}`);
};
export const getMonitorNotes = async (protocolId, documentId) => {
    return axios.get(`api/v1/visitTracking/DocumentNotes/monitornote/${documentId}/protocol/${protocolId}`);
};
export const getMonitorNote = async (protocolId, noteId) => {
    return axios.get(`api/v1/visitTracking/DocumentNotes/protocol/${protocolId}/monitornote/${noteId}`);
};
export const createMonitorNote = async (documentId, protocolId, visitId, patientId, note) => {
    return axios.post(`api/v1/visitTracking/DocumentNotes/monitornote/${documentId}/protocol/${protocolId}/visit/${visitId}/patient/${patientId}`, note);
};
export const updateMonitorNote = async (protocolId, noteId, note) => {
    return axios.put(`api/v1/visitTracking/DocumentNotes/protocol/${protocolId}/monitornote/${noteId}`, note);
};
export const changeStatusMonitorNote = async (protocolId, noteId, note) => {
    return axios.put(`api/v1/visitTracking/DocumentNotes/protocol/${protocolId}/monitornote/${noteId}/status`, note);
};
export const removeMonitorNote = async (protocolId, noteId) => {
    return axios.delete(`api/v1/visitTracking/DocumentNotes/protocol/${protocolId}/monitornote/${noteId}`);
};
//#endregion

//#region Branches
export const getBranches = async (protocolId) =>
    axios.get(`api/v1/Branches/protocols/${protocolId}`);

export const createBranch = async (protocolId, branch) =>
    axios.post(`api/v1/Branches/protocols/${protocolId}`, branch);

export const updateBranch = async (protocolId, branchId, branch) =>
    axios.put(`api/v1/Branches/protocols/${protocolId}/${branchId}`, branch);

export const deleteBranch = async (protocolId, branchId) =>
    axios.delete(`api/v1/Branches/protocols/${protocolId}/${branchId}`);

export const assignVisitBranches = async (protocolId, visitId, branchIds) =>
    axios.put(`api/v1/Branches/protocols/${protocolId}/visits/${visitId}`, { branchIds });

export const assignPatientBranch = async (protocolId, numberInProtocol, branchId) =>
    axios.post(`api/v1/Branches/protocols/${protocolId}/patients/${numberInProtocol}/branch`, { branchId });

export const changePatientBranch = async (protocolId, numberInProtocol, branchId) =>
    axios.put(`api/v1/Branches/protocols/${protocolId}/patients/${numberInProtocol}/branch`, { branchId });

export const getPatientCurrentBranch = async (protocolId, numberInProtocol) =>
    axios.get(`api/v1/Branches/protocols/${protocolId}/patients/${numberInProtocol}/branch`);

export const getPatientBranchHistory = async (protocolId, numberInProtocol) =>
    axios.get(`api/v1/Branches/protocols/${protocolId}/patients/${numberInProtocol}/branch/history`);
//#endregion